import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../extended/new';
import '../dialog/AppointmentDialog';
import { IntermediateListItem, Color } from '../dataTable/dataTable';
import * as moment from "moment";
import "../../../node_modules/moment/locale/de.js";
import * as fs from 'fs';
import { Postbox, PostboxPaging } from "../postbox/postbox";
import "../dialog/editDeadlineDialog";
import "../dialog/editAppointmentDialog";
import { RolesAndRights } from "../../helpers/RolesAndRights";
export class VerificationViewModel {
    appointments = ko.observableArray([]);
    deadlines = ko.observableArray([]);
    todos = ko.observableArray([]);
    openDashboardAppointment = ko.observable();
    appointmentId = ko.observable();
    filter = ko.observable("");
    sachbearbeiter = ko.observable("");
    selectedVB = ko.observable("");
    ProcessPartner = ko.observable("");
    ProcessPartnerId = ko.observable("");
    ProcessClient = ko.observable("");
    ProcessClientId = ko.observable("");
    Fristenkontrolle = ko.observable("");
    FristenkontrolleId = ko.observable("");
    FristenkontrolleTermine = ko.observable("");
    FristenkontrolleTermineId = ko.observable("");
    reportType = ko.observable("undone");
    reportFormat = ko.observable("word");
    editableFilter = ko.observable("Editable");
    rStartDate = ko.observable("");
    rEndDate = ko.observable("");
    dailyReportDate = ko.observable("");
    values = ko.observable({
        complete: ko.observable(true),
        yellow: ko.observable(true),
        red: ko.observable(true),
        bell: ko.observable(true),
        isDeleted: ko.observable(true)
    });
    types = ko.observable({
        Frist: ko.observable(true),
        Vorfrist: ko.observable(true),
        Termin: ko.observable(true)
    });
    currentID = ko.observable('');
    hasButton = ko.observable(true);
    checkDeadline = ko.observable(true);
    checkPreDeadline = ko.observable(true);
    checkApp = ko.observable(true);
    checkResub = ko.observable(true);
    tooltips = ko.observableArray([{ name: 'TypeId', col: 'subject' }]);
    showTermine = ko.observable(false);
    showFristen = ko.observable(false);
    showFTWFilter = ko.observable(true);
    calledfirst = ko.observable(true);
    allStandorte = ko.observableArray([]);
    hasReferatCount = ko.observable(0);
    currentRubrum = ko.observable('');
    AllReferate = ko.observable();
    showParameterMessage = ko.observable(false);
    emptyStandorte = ko.observable(true);
    extendDeadlineReason = ko.observable('');
    rejectionReasonAppointment = ko.observable('');
    isAppointmentHistoryModal = ko.observable(true);
    fKAId = ko.observable('');
    fkAName = ko.observable('');
    showError = ko.observable(false);
    showExternError = ko.observable(false);
    showSuccess = ko.observable(false);
    showExternSuccess = ko.observable(false);
    showOutlookLoader = ko.observable(false);
    OutlookAccounts = ko.observableArray([]);
    selectedFilterStandort = ko.observable("");
    selectedFilterStandortKontrollblatt = ko.observable("");
    selectedFilterAccount = ko.observable("");
    selectedFilterAccountKontrollblatt = ko.observable("");
    selectedInstance = ko.observable("");
    isViewerRole = ko.observable<boolean>(false);
    attendees = ko.observableArray([]);
    startRepDeadline = ko.observable('');
    endRepDeadline = ko.observable('');
    caseRepDeadline = ko.observable('');
    deadlineLength = ko.observable('');
    allUsers = ko.observableArray();
    showPrintLoader = ko.observable(false);
    showPrintError = ko.observable(false);
    showPrintErrorNoDeadlines = ko.observable(false);
    showPrintErrorNoAppointments = ko.observable(false);
    showReportError = ko.observable(false);
    showReportVBError = ko.observable(false);
    showReportVBMandantError = ko.observable(false);
    showReportMandantError = ko.observable(false);
    showNoDeadlinesFound = ko.observable(false);
    addres = ko.observable("");
    ReportFilter = ko.observable({
        CaseID: ko.observable(""),
        DoneOnly: ko.observable(false),
        BothTypes: ko.observable(false),
        DocFile: ko.observable(false),
        Locations: ko.observableArray(null),
        ClerkID: ko.observable(""),
        Standorte: ko.observableArray(null),
    });
    readonly DANGER_COLOR: Color = {
        color: "white",
        "background-color": "#e21b38"
    };
    filteredTodos: ko.Computed<any>;
    filterType(type: string) {
        if (type == 'frist') {
            this.types().Frist(this.checkDeadline());
        }
        else if (type == 'vorfrist') {
            this.types().Vorfrist(this.checkPreDeadline());
        }
        else if (type == 'termin') {
            this.types().Termin(this.checkApp());
        }
        this.filter(this.filter());
    }
    deadlineToBeModified = ko.observable(null);
    appointmentToBeModified = ko.observable(null);
    hasVerificationRights = ko.observable(false);
    filterWithStars(item, filters) {
        if (item['stars'] && filters.indexOf(item['stars']) !== -1)
            return true;
        return false;
    }
    filterWithVB(item, filters) {
        let isInVb = false;
        if (item.entryType === 'deadline') {
            for (let i = 0; i < item.originalObj.InstanceClerks.length; i++) {
                if (item.originalObj.InstanceClerks[i].Sachbearbeiter_ID === filters)
                    isInVb = true;
            }
        }
        else {
            for (let i = 0; i < item.originalObj.VBs.length; i++) {
                if (item.originalObj.VBs[i].Sachbearbeiter_ID === filters)
                    isInVb = true;
            }
        }
        return isInVb;
    }
    filterWithType(item, filters) {
        if (item['entryTypeName'] && filters.indexOf(item['entryTypeName']) !== -1)
            return true;
        return false;
    }
    filterWithStandort(item) {
        if (item['ref'] && ko.toJS(this.selectedFilterStandort) === item['ref'])
            return true;
        return false;
    }
    filterWithEditable(item) {
        const handlers = item && item['actionHandlers'];
        if (Array.isArray(handlers))
            return handlers.filter(a => typeof a.icon === 'string' && a.icon.includes("text-muted")).length === 0;
        return false;
    }
    filterWithFKA(item) {
        if (item['fka'] && ko.toJS(this.selectedFilterAccount) === item['fka'])
            return true;
        return false;
    }
    filterWithInstance(item) {
        if (item['instanceId'] && ko.toJS(this.selectedInstance) === item['instanceId'])
            return true;
        return false;
    }
    getNextWV(items) {
        if (items.length > 0) {
            let found = false;
            let intervall = 1;
            let notify = false;
            for (let i = items.length - 1; i >= 0; i--) {
                if (items[i].stars === "red")
                    notify = true;
                if (items[i].entryType === "resubmission") {
                    if (Number(moment(ko.toJS(items[i].date), "DD.MM.YYYY").format("YYYYMMDD")) >= Number(moment().format("YYYYMMDD"))) {
                        found = true;
                    }
                    else {
                        if (found) {
                            $("#NextWVCase").removeClass("hide");
                            $("#NextWVCaseLbl").removeClass("hide");
                            $("#grundcaseWV").val(items[i + intervall].subject);
                            $("#deadlineDateCaseWV").val(moment(items[i + intervall].date, "DD.MM.YYYY").format("YYYY-MM-DD"));
                            $("#SBcaseWV").val(items[i + intervall].SB);
                            break;
                        }
                    }
                    intervall = 1;
                }
                else {
                    intervall++;
                }
            }
            if (notify) {
                $("#redNotificationCircle").attr("style", "font-size: 0.75rem; vertical-align: middle !important; margin-bottom: 0.4rem; display: inline-block");
                $("#redNotificationCircleTFW").attr("style", "font-size: 0.5rem; vertical-align: middle !important; margin-bottom: 0.1rem; display: inline-block");
            }
        }
    }
    public getVM = () => this;
    async updateTodos(appointments: any, deadlines: any) {
        try {
            let transformedAppointments = appointments.map(obj => this.transformAppointmentData(obj, "appointment"));
            if (transformedAppointments.length > 0)
                this.showTermine(true);
            else
                this.showTermine(false);
            let startAsNumber = Number(moment(ko.toJS(this.rStartDate)).format("YYYYMMDD"));
            let endAsNumber = Number(moment(ko.toJS(this.rEndDate)).format("YYYYMMDD"));
            let transformedDeadlines = deadlines.map(obj => this.transformDeadlineData(obj, "deadline", startAsNumber, endAsNumber));
            if (transformedDeadlines.length > 0)
                this.showFristen(true);
            else
                this.showFristen(false);
            let transformedResubmissions = [];
            let todos: any;
            if (this.checkDeadline() && !this.checkResub() && this.checkApp()) {
                todos = (transformedAppointments.concat(transformedDeadlines));
            }
            if (this.checkDeadline() && this.checkResub() && !this.checkApp()) {
                todos = (transformedDeadlines.concat(transformedResubmissions));
            }
            if (!this.checkDeadline() && this.checkResub() && this.checkApp()) {
                todos = (transformedAppointments
                    .concat(transformedResubmissions));
            }
            if ((this.checkDeadline() && this.checkResub() && this.checkApp()) || !this.checkDeadline() && !this.checkResub() && !this.checkApp()) {
                todos = (transformedAppointments.concat(transformedDeadlines)
                    .concat(transformedResubmissions));
            }
            if ((this.checkDeadline() && (!this.checkResub() && !this.checkApp()))) {
                todos = transformedDeadlines;
            }
            if ((!this.checkDeadline() && this.checkResub()) && !this.checkApp()) {
                todos = transformedDeadlines;
            }
            if ((!this.checkDeadline() && (this.checkResub() && !this.checkApp()))) {
                todos = transformedResubmissions;
            }
            if ((!this.checkDeadline() && (!this.checkResub() && this.checkApp()))) {
                todos = transformedAppointments;
            }
            this.showFTWFilter(ko.toJS(this.showFristen) && ko.toJS(this.showTermine));
            let sortedTodos = todos.sort((t1: IntermediateListItem, t2: IntermediateListItem) => {
                if (t1.dateObj.isBefore(t2.dateObj)) {
                    return 1;
                }
                else {
                    return -1;
                }
            }).map(obj => {
                if ((obj.entryTypeName === "Frist" || obj.entryType === "ecase" || obj.entryTypeName === "Vorfrist" || obj.entryTypeName === "Wiedervorlage" || obj.entryTypeName === "Termin") && !this.isViewerRole()) {
                    obj.columnActions = {
                        "number": MainViewModel.RoutingTable.generateLink(`/new/${encodeURIComponent(obj.number)}`)
                    };
                }
                return obj;
            }).reverse();
            this.todos(sortedTodos);
        }
        catch (e) {
            console.log(e);
        }
    }
    transformAppointmentData(obj: any, type: string) {
        let actionList = [];
        obj.CreatedAtDateFormated = ko.toJS(moment(ko.toJS(obj.CreationDate)).format("DD.MM.YYYY"));
        obj.CreatedFromFormated = ko.toJS(this.getUserForShorthand(obj.CreatorId));
        obj.DeletedByIdFormated = ko.toJS(this.getUserForShorthand(obj.DeletedById));
        if (obj.DeletedOn !== null) {
            obj.DeletedOnFormated = ko.toJS(moment(ko.toJS(obj.DeletedOn)).format("DD.MM.YYYY"));
        }
        else {
            obj.DeletedOnFormated = "N/A";
        }
        if (obj.EditedAtDate !== null) {
            obj.EditedAtDateFormated = ko.toJS(moment(ko.toJS(obj.EditedAtDate)).format("DD.MM.YYYY"));
            obj.EditedFromFormated = ko.toJS(this.getUserForShorthand(obj.EditorId));
        }
        if (obj.VerifiedOn !== null) {
            obj.VerifiedOnFormated = ko.toJS(moment(ko.toJS(obj.VerifiedOn)).format("DD.MM.YYYY"));
            obj.VerifiedByFormated = ko.toJS(this.getUserForShorthand(obj.VerifiedBy));
        }
        obj.StartFormated = ko.toJS(moment(ko.toJS(obj.StartDate)).format("DD.MM.YYYY HH:mm")) + " Uhr";
        obj.EndFormated = ko.toJS(moment(ko.toJS(obj.EndDate)).format("DD.MM.YYYY HH:mm")) + " Uhr";
        if (ko.toJS(obj.StartFormated).endsWith("00:00 Uhr") && ko.toJS(obj.EndFormated).endsWith("23:59 Uhr")) {
            obj.StartFormated = ko.toJS(moment(ko.toJS(obj.StartDate)).format("DD.MM.YYYY"));
            obj.EndFormated = ko.toJS(moment(ko.toJS(obj.EndDate)).format("DD.MM.YYYY"));
        }
        obj.AppointmentTypeFormated = obj.AppointmentType.Name ? obj.AppointmentType.Name : "Unbekannte Terminart";
        let history = {
            icon: "history", name: "Verlauf", action: async () => {
                PostboxPaging.publisher().publish({ Appointment: obj, Mode: 0 }, "EditAppointmentModalData");
            }
        };
        actionList.push(history);
        let verificationCheckMuted = {
            icon: "check-double text-muted", name: "Dieser Termin muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => { }
        };
        let verificationCheck = {
            icon: "check-double", name: "Dieser Termin muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => {
                PostboxPaging.publisher().publish({ Appointment: obj, Mode: 1 }, "EditAppointmentModalData");
            }
        };
        let editAppointment = {
            icon: "pencil-alt", name: "Bearbeiten", action: () => {
                this.openDashboardAppointment(true);
                this.IsEditMode(true);
                this.appointmentId(obj.Id);
                Postbox.publisher().publish(obj.Id, "FillAppointmentDataWithID");
                $("#AppointmentVerificationmodal").modal("show");
            }
        };
        let deleteAppointment = {
            icon: "trash-alt",
            name: "Löschen",
            action: async () => {
                PostboxPaging.publisher().publish({ Appointment: obj, Mode: 3 }, "EditAppointmentModalData");
            }
        };
        if (!obj.Completed && !obj.IsDeleted) {
            if (!this.isViewerRole()) {
                actionList.push(deleteAppointment);
                if (obj.HasToBeVerified) {
                    if (obj.VerifiedOn !== null) {
                        actionList.push(editAppointment);
                    }
                }
                else {
                    actionList.push(editAppointment);
                }
            }
        }
        let stars = "";
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        let d = new Date(obj.EndDate);
        d.setHours(0, 0, 0, 0);
        if (obj.Completed) {
            stars = "complete";
        }
        else {
            if (d < today && !obj.IsDeleted) {
                stars = "red";
            }
            else if (obj.IsDeleted) {
                stars = "isDeleted";
            }
            else {
                stars = "yellow";
            }
        }
        if (ko.toJS(this.AllReferate).length > 0) {
            let refs = ko.toJS(this.AllReferate);
            let loc = refs.filter(a => a.Id == obj.LocationId);
            if (loc.length === 1)
                obj.locationID = loc[0].Id;
            else
                obj.locationID = "";
        }
        else
            obj.locationID = "";
        obj.fka = obj.Fka;
        if (!this.isViewerRole()) {
            if (obj.HasToBeVerified && obj.VerifiedOn === null && obj.CreatorId === RNSAPI.getCurrentLoggedInUser().ShortHandSymbol) {
                actionList.push(verificationCheckMuted);
            }
            if (obj.HasToBeVerified && obj.VerifiedOn === null && obj.CreatorId !== RNSAPI.getCurrentLoggedInUser().ShortHandSymbol) {
                actionList.push(verificationCheck);
            }
        }
        let vbs = "";
        for (let vb of obj.VBs) {
            if (vbs === "")
                vbs = vb.Sachbearbeiter_ID;
            else
                vbs = vbs + ' ' + vb.Sachbearbeiter_ID;
        }
        return new IntermediateListItem(stars, type, nameTable[type], obj.StartDate, obj.AppointmentSubject, obj.CaseId, obj, actionList, undefined, obj.Rubrum, obj.SB, obj.AppointmentNote, obj.locationID, obj.fka, obj.Instance, obj.CourtInstanceId, null, vbs);
    }
    transformDeadlineData(obj: any, type: string, start: Number, end: Number) {
        obj.PreDeadline2 = ko.toJS(moment(ko.toJS(obj.PreDeadline)).format("DD.MM.YYYY"));
        obj.PreDeadlinesFormated = [];
        for (let i = 0; i < obj.PreDeadlines.length; i++) {
            var formatedPreDeadline = ko.toJS(moment(ko.toJS(obj.PreDeadlines[i])).format("DD.MM.YYYY"));
            obj.PreDeadline2 = obj.PreDeadline2 + "      " + formatedPreDeadline;
            obj.PreDeadlinesFormated.push(formatedPreDeadline);
        }
        let extendable = [
            {
                icon: "pencil-alt", name: "Verlängern", action: async () => {
                    PostboxPaging.publisher().publish({ Deadline: obj, Mode: 2 }, "EditDeadlineModalData");
                }
            }
        ];
        let verificationCheckMuted = {
            icon: "check-double text-muted", name: "Diese Frist muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => { }
        };
        let verificationCheck = {
            icon: "check-double", name: "Diese Frist muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => {
                PostboxPaging.publisher().publish({ Deadline: obj, Mode: 1 }, "EditDeadlineModalData");
            }
        };
        let actionList = [
            {
                icon: "history", name: "Verlauf", action: async () => {
                    PostboxPaging.publisher().publish({ Deadline: obj, Mode: 0 }, "EditDeadlineModalData");
                }
            }
        ];
        obj.fka = obj.FKAName;
        if (obj.Status !== "complete" && !this.isViewerRole()) {
            if (obj.openVerificationRejected) {
                if (obj.openVeriticationType === 0 || obj.openVeriticationType === 3) {
                    actionList.push(extendable[0]);
                }
                else {
                    if (obj.openVerification && obj.openVerificationUser === RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                        actionList.push(verificationCheckMuted);
                    if (obj.openVerification && obj.openVerificationUser !== RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                        actionList.push(verificationCheck);
                }
            }
            if (obj.openVerification && obj.openVerificationRejected === false && obj.openVerificationUser === RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                actionList.push(verificationCheckMuted);
            if (obj.openVerification && obj.openVerificationRejected === false && obj.openVerificationUser !== RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                actionList.push(verificationCheck);
        }
        return new IntermediateListItem(obj.Status, type, nameTable[type], obj.Deadline, obj.TypeDescription, obj.CaseId, obj, actionList, undefined, obj.Rubrum, obj.SB, obj.Note, obj.locationID, obj.fka, obj.InstanceData ? obj.InstanceData.CourtInstanceName + ' ' + obj.InstanceData.CourtName : '', obj.InstanceData ? obj.InstanceData.Id : undefined, obj.PreDeadline2, obj.VBs, obj.CurrentFVA);
    }
    getUserForShorthand(shorthand: string) {
        for (let i = 0; i < this.allUsers().length; i++) {
            if (ko.toJS(this.allUsers())[i].Shorthandsymbol === shorthand)
                return ko.toJS(this.allUsers())[i].Name.replace('Bitte wählen Sie', '').replace('Frau', '').replace('Herr', '');
        }
        return "";
    }
    async getAllUsers() {
        let res = (await RNSAPI.getLawFirmUsers()).Payload.Users;
        this.allUsers(res);
    }
    public async update() {
        let allAppointments = await RNSAPI.getAppointmentsToVerify();
        let allDeadlines = await RNSAPI.getDeadlinesToVerify();
        this.updateTodos(allAppointments.Payload.Appointments, allDeadlines.Payload.Deadlines);
    }
    newAkteFrist() {
        let obj = {
            SachbearbeiterId: ko.observable(RNSAPI.User().username),
            Sachbearbeiter: ko.observable(null),
            Clerk: ko.observable(null),
            CaseId: ko.observable(null),
            Rubrum: ko.observable("Kein Rubrum vorhanden."),
            DeadlineNumber: ko.observable("-/-"),
            DeadlineText: ko.observable(null),
            CompletedBy: ko.observable(""),
            CompletionDate: ko.observable(""),
            CreatedBy: ko.observable(""),
            StartDate: ko.observable(moment().format("YYYY-MM-DD")),
            PreDeadline: ko.computed(() => {
                if (this.predeadlineNr().startsWith("w")) {
                    let weeks = this.predeadlineNr()[1] + this.predeadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(weeks, "w");
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.predeadlineNr().startsWith("m")) {
                    let months = this.predeadlineNr()[1] + this.predeadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(months, "M");
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.predeadlineNr().startsWith("j")) {
                    let year = this.predeadlineNr()[1] + this.predeadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(year, "y");
                    return FristDay.format("YYYY-MM-DD");
                }
                else {
                    return moment().format("YYYY-MM-DD");
                }
            }),
            TheDeadline: ko.computed(() => {
                if (this.deadlineNr().startsWith("w")) {
                    let weeks = this.deadlineNr()[1] + this.deadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(weeks, "w");
                    if (FristDay.day() == 0) {
                        FristDay.add(1, 'day');
                    }
                    else if (FristDay.day() == 6) {
                        FristDay.add(2, 'day');
                    }
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.deadlineNr().startsWith("m")) {
                    let months = this.deadlineNr()[1] + this.deadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(months, "M");
                    if (FristDay.day() == 0) {
                        FristDay.add(1, 'day');
                    }
                    else if (FristDay.day() == 6) {
                        FristDay.add(2, 'day');
                    }
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.deadlineNr().startsWith("j")) {
                    let year = this.deadlineNr()[1] + this.deadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(year, "y");
                    if (FristDay.day() == 0) {
                        FristDay.add(1, 'day');
                    }
                    else if (FristDay.day() == 6) {
                        FristDay.add(2, 'day');
                    }
                    return FristDay.format("YYYY-MM-DD");
                }
                else {
                }
            })
        };
        return ko.observable(obj);
    }
    ;
    deadlineNr = ko.observable("");
    predeadlineNr = ko.observable("");
    IsEditMode = ko.observable(false);
    akteFrist = this.newAkteFrist();
    async verifyRejectAppointment() {
        this.rejectionReasonAppointment("");
        $("#reasonForRejectionAppointment_inp").removeClass("has-error");
        $("#rejectVerifyConclusionAppointment_Body").removeClass("hide");
        $("#rejectVerifyConclusionAppointment_Body").addClass("show");
        $("#verifyConclusionAppointment_Body").removeClass("show");
        $("#verifyConclusionAppointment_Body").addClass("hide");
    }
    async abortRejectAppointment() {
        $("#verifyConclusionAppointment_Body").removeClass("hide");
        $("#verifyConclusionAppointment_Body").addClass("show");
        $("#rejectVerifyConclusionAppointment_Body").removeClass("show");
        $("#rejectVerifyConclusionAppointment_Body").addClass("hide");
    }
    async getFKA(caseId) {
        let AccountId = await this.getFristenKalenderForCaseId(caseId);
        let result = (await RNSAPI.getOutlook());
        if (result.Type === "GetAccountsSuccessful") {
            let res = result.Payload.OutlookAccounts;
            if (res.length > 0) {
                let account = "";
                let accountId = "";
                for (let acc of res) {
                    if (acc.OutlookAccountID === AccountId.FKAId) {
                        account = acc.UserLogin;
                        accountId = acc.OutlookAccountID;
                    }
                }
                this.fkAName(account);
                this.fKAId(accountId);
            }
        }
    }
    async getFristenKalenderForCaseId(caseId): Promise<any> {
        let result = { FKA: "", FKAId: "" };
        if (caseId !== "" && caseId !== null) {
            let res = (await RNSAPI.getExtendedCase(caseId)).Payload;
            result.FKA = res.Akte.DeadlineCalendarAccount;
            result.FKAId = res.Akte.DeadlineCalendarAccountId;
            this.attendees(res.Akte.WeitereSachbearbeiterRecords);
        }
        return result;
    }
    async getOutlookAccounts() {
        let result = (await RNSAPI.getOutlook());
        if (result.Type === "GetAccountsSuccessful") {
            let res = result.Payload.OutlookAccounts;
            this.OutlookAccounts(res);
        }
        else
            this.OutlookAccounts([]);
    }
    async pickCase5() {
        let cases = [];
        await RNSAPI.getCasesOverview().then((data) => {
            cases = data as any;
        }).catch((error) => {
            cases = [];
        });
        this.pickGeneric("Akte", ["caseid", "rubrum", "court_caseid_1", "refId"], ["Akte", "Rubrum", "AZ-Gericht 1. Instanz", "Standort"], cases);
        this.modalHandleSelection((selectedObject) => {
            this.currentRubrum(selectedObject()["rubrum"]);
            this.filter(selectedObject()["caseid"]);
        });
        $('#modal').modal('show');
    }
    ;
    async pickClerk5() {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Fristenkontrolle wählen", ["Sachbearbeiter"], ["Fristenkontrolle"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.sachbearbeiter(selectedObject()["Sachbearbeiter"]);
        });
        $('#modal').modal('show');
    }
    ;
    async pickVB() {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Verfahrensbearbeiter wählen", ["Sachbearbeiter"], ["Verfahrensbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.selectedVB(selectedObject()["Sachbearbeiter_ID"]);
        });
        $('#modal').modal('show');
    }
    async pickVBReport(position) {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter((s) => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Verfahrensbearbeiter wählen", ["Sachbearbeiter"], ["Verfahrensbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            if (position === "FristenkontrolleTermine") {
                this.FristenkontrolleTermine(selectedObject()["Sachbearbeiter"]);
                this.FristenkontrolleTermineId(selectedObject()["Sachbearbeiter_ID"]);
            }
            else if (position === "ProcessPartner") {
                this.ProcessPartner(selectedObject()["Sachbearbeiter"]);
                this.ProcessPartnerId(selectedObject()["Sachbearbeiter_ID"]);
            }
        });
        $("#modal").modal("show");
    }
    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    }
    ;
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection = ko.observable();
    TermiCount = ko.observable(0);
    async getReferate() {
        let referate = (await RNSAPI.getReferate()).Payload.Units;
        this.hasReferatCount(referate.length);
        let ref = referate.map((r) => {
            r.Checked = false;
            return r;
        });
        this.AllReferate(ref);
    }
    constructor(params: any) {
        this.isViewerRole(RolesAndRights.isViewerRole());
        let user = RNSAPI.getCurrentLoggedInUser();
        if (user.UseVerificationWorkflow === "1") {
            this.hasVerificationRights(true);
        }
        moment.locale("de");
        this.hasButton(true);
        if (params.id !== undefined) {
            this.currentID(ko.toJS(params.id));
            this.filter(ko.toJS(params.id));
            this.hasButton(false);
            Postbox.publisher().publish("", "checkReferate");
        }
        else {
            this.rStartDate(ko.toJS(moment().format("YYYY-MM-DD")));
            this.rEndDate(ko.toJS(moment().format("YYYY-MM-DD")));
        }
        this.getAllUsers();
        this.update();
        Postbox.publisher().subscribe(() => {
            this.update();
        }, 'updateTFW');
        this.filteredTodos = ko.computed({
            owner: this,
            read: () => {
                let filter = this.filter();
                let sachbearbeiter = this.sachbearbeiter();
                let vb = this.selectedVB();
                let filters = [];
                if (this.values().complete()) {
                    filters.push('complete');
                }
                else {
                    filters.indexOf('complete') !== -1 ? filters.splice(filters.indexOf('complete'), 1) : null;
                }
                if (this.values().yellow()) {
                    filters.push('yellow');
                }
                else {
                    filters.indexOf('yellow') !== -1 ? filters.splice(filters.indexOf('yellow'), 1) : null;
                }
                if (this.values().red()) {
                    filters.push('red');
                }
                else {
                    filters.indexOf('red') !== -1 ? filters.splice(filters.indexOf('red'), 1) : null;
                }
                if (this.values().isDeleted()) {
                    filters.push("isDeleted");
                }
                else {
                    filters.indexOf("isDeleted") !== -1
                        ? filters.splice(filters.indexOf("isDeleted"), 1)
                        : null;
                }
                if (this.values().bell()) {
                    filters.push('bell');
                }
                else {
                    filters.indexOf('bell') !== -1 ? filters.splice(filters.indexOf('bell'), 1) : null;
                }
                const filterTypes = Object.keys(this.types()).filter(item => this.types()[item]());
                let items = this.todos();
                if (ko.toJS(this.selectedFilterStandort()) !== "")
                    items = items.filter(item => this.filterWithStandort(item));
                if (ko.toJS(this.selectedFilterAccount()) !== "")
                    items = items.filter(item => this.filterWithFKA(item));
                if (ko.toJS(this.selectedInstance()) !== "")
                    items = items.filter(item => this.filterWithInstance(item));
                if (ko.toJS(this.editableFilter()) !== "All")
                    items = items.filter(item => this.filterWithEditable(item));
                if (filters.length) {
                    items = items.filter(item => this.filterWithStars(item, filters));
                }
                if (filterTypes.length) {
                    items = items.filter(item => this.filterWithType(item, filterTypes));
                }
                if (filter) {
                    items = items.filter(item => item['number'] && item['number'].indexOf(filter) !== -1);
                }
                if (sachbearbeiter) {
                    items = items.filter(item => item['SB'] && item['SB'].includes(sachbearbeiter));
                }
                if (vb) {
                    items = items.filter(item => this.filterWithVB(item, vb));
                }
                if (ko.toJS(this.currentID) !== '' && ko.toJS(this.currentID) !== "undefined") {
                    this.getNextWV(items);
                }
                return items;
            }
        });
        this.rStartDate.subscribe(() => this.update());
        this.rEndDate.subscribe(() => this.update());
        Postbox.publisher().subscribe((start: string, end: string) => {
            this.startRepDeadline(start);
            this.endRepDeadline(end);
        }, 'UpdateRepDeadlines');
        this.getReferate();
        this.getOutlookAccounts();
    }
}
let nameTable: {
    [key: string]: string;
} = {
    "appointment": "Termin",
    "deadline": "Frist",
    "predeadline": "Vorfrist",
    "inbox": "Posteingang",
    "resubmission": "Wiedervorlage",
    "ecase": "EAkte"
};
var html = fs.readFileSync(__dirname + '/verification.html', 'utf8');
ko.components.register("verification-view", {
    viewModel: VerificationViewModel,
    template: html
});
